import React from 'react';
import MainInterface from './components/MainInterface';

function App() {
  return <MainInterface />;
}

export default App;